import React, { useState, useEffect } from 'react'
import Zemelapis from '../components/Zemelapis'
import RuleteRezultatas from './RuleteRezultatas'
import RuleteAnimacija from '../components/RuleteAnimacija'
import { supabase } from '../utils/supabaseClient'
import useLocation from '../hooks/useLocation'
import { haversine, arAtviraDabar } from '../utils/atstumas'
import ProfilioLentele from '../components/ProfilioLentele'
import IssaugotosVietos from './IssaugotosVietos'
import AtsiliepimasEkranas from './AtsiliepimasEkranas'
import PaieskaEkranas from './PaieskaEkranas'
import Profilis from './Profilis'
import ZenkliukaiEkranas from './ZenkliukaiEkranas'
import IssukiaiEkranas from './IssukiaiEkranas'
import NustatymaiEkranas from './NustatymaiEkranas'
import KalbaEkranas from './KalbaEkranas'
import PrenumerataEkranas from './PrenumerataEkranas'
import PagalbaEkranas from './PagalbaEkranas'
import PrisiminimoPatvirtinimas from '../components/PrisiminimoPatvirtinimas'
import CoachMark from '../components/CoachMark'
import { arMatyta, pazymetiMatyta, pazymetiMatytaKeli } from '../utils/onboarding'
import { pridetiNeseniai } from '../utils/neseniai'
import { suspaustiNuotrauka } from '../utils/nuotrauku_saugykla'
import { pridetiPrisiminima } from '../utils/prisiminimai'
import { pridetiAplankyta } from '../utils/aplankytos'
import { getNumatytaKm } from '../utils/kelias'

// value = DB reikšmė (be nosinių), label = kaip rodom vartotojui
const KATEGORIJOS = [
  { value: 'visos', label: 'visos' },
  { value: 'gamta', label: 'gamta' },
  { value: 'jura', label: 'jūra' },
  { value: 'istorija', label: 'istorija' },
  { value: 'miestas', label: 'miestas' },
  { value: 'vaikams', label: 'vaikams' },
]
const PAPILDOMAI_VARIANTAI = ['nemokama', 'tinka vaikams', 'atvira dabar']

// Lietuviška „vieta" daugiskaita: 1 vieta, 2 vietos, 11 vietų, 21 vieta...
function vietosZodis(n) {
  const d = n % 10
  const dd = n % 100
  if (d === 0 || (dd >= 11 && dd <= 19)) return 'vietų'
  if (d === 1) return 'vieta'
  return 'vietos'
}

function Rulete() {
  const [aktyviKategorija, setAktyviKategorija] = useState('visos')
  const [atstumas, setAtstumas] = useState(30)
  const [papildomai, setPapildomai] = useState([])
  const [sheetMini, setSheetMini] = useState(false)
  const [vietos, setVietos] = useState([])
  const [pasirinkta, setPasirinkta] = useState(null)
  const [kitos, setKitos] = useState([])
  const [animacija, setAnimacija] = useState(null)
  const [nieko, setNieko] = useState(false)
  const [rankinis, setRankinis] = useState(false)
  const [centruotiSignalas, setCentruotiSignalas] = useState(0)
  const [paieskaAtidaryta, setPaieskaAtidaryta] = useState(false)
  const [zemelapioPaieska, setZemelapioPaieska] = useState(null)
  const [profilis, setProfilis] = useState(false)

  function rodytiZemelapyje(rez, fraze) {
    setZemelapioPaieska({ fraze, vietos: rez })
    setPaieskaAtidaryta(false)
    setSheetMini(false)
  }
  const [issaugotosAtidaryta, setIssaugotosAtidaryta] = useState(false)
  const [atsiliepimasAtidaryta, setAtsiliepimasAtidaryta] = useState(false)
  const [profilisEkranas, setProfilisEkranas] = useState(false)
  const [zenkliukaiAtidaryta, setZenkliukaiAtidaryta] = useState(false)
  const [issukiaiAtidaryta, setIssukiaiAtidaryta] = useState(false)
  const [nustatymaiAtidaryta, setNustatymaiAtidaryta] = useState(false)
  const [kalbaAtidaryta, setKalbaAtidaryta] = useState(false)
  const [prenumerataAtidaryta, setPrenumerataAtidaryta] = useState(false)
  const [pagalbaAtidaryta, setPagalbaAtidaryta] = useState(false)
  const [toast, setToast] = useState(null)

  // Globalus „Buvau čia" (header kamerėlė)
  const [prTaskas, setPrTaskas] = useState(null) // { dataUrl, gps }
  const [prKandidatai, setPrKandidatai] = useState([])
  const [prVieta, setPrVieta] = useState(null)
  const [prSaugoma, setPrSaugoma] = useState(false)
  const globalusFailoRef = React.useRef(null)

  // Mikro-onboarding (pagrindinio ekrano seka)
  const filtraiRef = React.useRef(null)
  const vezkRef = React.useRef(null)
  const kameraRef = React.useRef(null)
  const [pagrZingsnis, setPagrZingsnis] = useState(-1)

  function rodytiToast(zinute) {
    setToast(zinute)
    setTimeout(() => setToast(t => (t === zinute ? null : t)), 2200)
  }

  function atidarytiKamera() {
    if (globalusFailoRef.current) globalusFailoRef.current.click()
  }

  async function globaliNuotrauka(e) {
    const file = e.target.files && e.target.files[0]
    e.target.value = ''
    if (!file) return
    try {
      const dataUrl = await suspaustiNuotrauka(file)
      // GPS ties fotkinimo momentu (tikslesnis nei paskutinė žinoma lokacija)
      const gps = await new Promise((res) => {
        if (!navigator.geolocation) { res(lokacija ? { lat: lokacija.lat, lng: lokacija.lng } : null); return }
        navigator.geolocation.getCurrentPosition(
          p => res({ lat: p.coords.latitude, lng: p.coords.longitude }),
          () => res(lokacija ? { lat: lokacija.lat, lng: lokacija.lng } : null),
          { enableHighAccuracy: true, timeout: 8000, maximumAge: 30000 }
        )
      })
      // Artimiausios vietos ~300 m spinduliu (kad nuotrauka „nepavogtų" tolimo pin'o)
      let kandidatai = []
      if (gps) {
        kandidatai = vietos
          .map(v => ({ ...v, dist: haversine(gps.lat, gps.lng, v.latitude, v.longitude) * 1000 }))
          .filter(v => v.dist <= 300)
          .sort((a, b) => a.dist - b.dist)
          .slice(0, 5)
      }
      setPrKandidatai(kandidatai)
      setPrVieta(kandidatai[0] || null)
      setPrTaskas({ dataUrl, gps })
    } catch {
      rodytiToast('Nepavyko apdoroti nuotraukos')
    }
  }

  async function issaugotiGlobaluPrisiminima() {
    if (!prTaskas) return
    setPrSaugoma(true)
    try {
      const gps = prTaskas.gps
      // km — tik jei vieta buvo atidaryta app'e (užfiksuota); kitaip nefiksuojam
      const km = prVieta ? getNumatytaKm(prVieta.id) : null
      await pridetiPrisiminima({
        vietaId: prVieta ? prVieta.id : null,
        pavadinimas: prVieta ? prVieta.pavadinimas : null,
        lat: gps ? gps.lat : null,
        lng: gps ? gps.lng : null,
        km,
        dataUrl: prTaskas.dataUrl,
      })
      if (prVieta) pridetiAplankyta(prVieta, { km, turiNuotrauka: true })
      setPrTaskas(null); setPrVieta(null); setPrKandidatai([])
      rodytiToast(prVieta ? `Pažymėta: ${prVieta.pavadinimas}` : 'Prisiminimas išsaugotas')
    } catch {
      rodytiToast('Nepavyko išsaugoti')
    } finally {
      setPrSaugoma(false)
    }
  }

  function pakviestiDrauga() {
    const url = 'https://kelioniuapp.lt'
    const tekstas = 'Atrask Lietuvą su Kelionių App — vienas mygtukas, viena vieta netoli tavęs.'
    if (navigator.share) {
      navigator.share({ title: 'Kelionių App', text: tekstas, url }).catch(() => {})
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(`${tekstas} ${url}`)
      rodytiToast('Nuoroda nukopijuota')
    } else {
      rodytiToast('Pasidalink: ' + url)
    }
  }
  const nuotraukaPasiruoseRef = React.useRef(false)
  const { lokacija, patikrinti } = useLocation()

  // Vietos, atitinkančios visus aktyvius filtrus
  function filtruotosVietos() {
    let f = [...vietos]
    if (aktyviKategorija !== 'visos') {
      f = f.filter(v => v.kategorija === aktyviKategorija)
    }
    if (papildomai.includes('nemokama')) {
      f = f.filter(v => v.nemokama === true)
    }
    if (papildomai.includes('tinka vaikams')) {
      f = f.filter(v => v.tinka_vaikams === true)
    }
    if (papildomai.includes('atvira dabar')) {
      f = f.filter(v => arAtviraDabar(v.darbo_laikas))
    }
    if (lokacija) {
      f = f.filter(v => haversine(lokacija.lat, lokacija.lng, v.latitude, v.longitude) <= atstumas)
    }
    return f
  }

  useEffect(() => {
    supabase.from('vietos').select('*').then(({ data }) => {
      if (data) setVietos(data)
    })
  }, [])

  // Mikro-onboarding: paleidžiam pagrindinio ekrano seką (kartą)
  useEffect(() => {
    if (vietos.length > 0 && pagrZingsnis === -1 && !arMatyta('ob_filtrai')) {
      const t = setTimeout(() => setPagrZingsnis(0), 700)
      return () => clearTimeout(t)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vietos])

  const PAGR_ZINGSNIAI = [
    { id: 'ob_filtrai', ref: filtraiRef, antraste: 'Filtrai', tekstas: 'Filtruok pagal kategoriją ir atstumą. Paslink žemyn — rasi ir „Papildomai": nemokama, vaikams, atvira dabar.' },
    { id: 'ob_vezk', ref: vezkRef, antraste: 'Vežk mane', tekstas: 'Nežinai kur? Paspausk — parinksim vietą pagal tavo filtrus.' },
    { id: 'ob_zemelapis', ref: null, antraste: 'Žemėlapis', tekstas: 'Gali rinktis ir tiesiai — paspausk vietą ant žemėlapio.' },
    { id: 'ob_kamera', ref: kameraRef, antraste: 'Buvau čia', tekstas: 'Nuvykęs nufotkink čia — pažymėsi vietą aplankyta ir užfiksuosi prisiminimą.' },
    { id: 'ob_taskai', ref: null, antraste: 'Kaip renkami taškai', tekstas: '„Buvau čia" įskaito aplankytą vietą, km, prisiminimus ir rekordus → lygis, ženkliukai, „Tavo Lietuva". Svarbu: rask vietą per app’ą prieš važiuodamas, kad km užsiskaitytų.' },
  ]

  function pagrKitas() {
    const z = PAGR_ZINGSNIAI[pagrZingsnis]
    if (z) pazymetiMatyta(z.id)
    if (pagrZingsnis >= PAGR_ZINGSNIAI.length - 1) { setPagrZingsnis(-1); setSheetMini(false) }
    else setPagrZingsnis(pagrZingsnis + 1)
  }
  function pagrPraleisti() {
    pazymetiMatytaKeli(PAGR_ZINGSNIAI.map(z => z.id))
    setPagrZingsnis(-1)
    setSheetMini(false)
  }

  // Onboarding metu: filtrai/vezk — lentelė viršuje; žemėlapis/kamera — nuleista (kad matytųsi pin'ai)
  useEffect(() => {
    if (pagrZingsnis < 0) return
    const id = PAGR_ZINGSNIAI[pagrZingsnis].id
    if (id === 'ob_zemelapis' || id === 'ob_kamera') setSheetMini(true)
    else if (id === 'ob_filtrai' || id === 'ob_vezk') setSheetMini(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagrZingsnis])

  useEffect(() => {
    const zoomControls = document.querySelector('.leaflet-control-zoom')
    if (zoomControls) {
      zoomControls.style.position = 'absolute'
      zoomControls.style.bottom = '12px'
      zoomControls.style.right = '8px'
      zoomControls.style.top = 'auto'
      zoomControls.style.left = 'auto'
    }
  }, [vietos])

  // naujasRankinis: true = savarankiškas rinkimasis (pagr. žemėlapio pin),
  // false = ruletė („Vežk mane"/„Vežk kitur"), undefined = paliekam kaip yra
  // (rekomendacija ar pin rezultato viduje — nekeičia režimo).
  function pasirinktiVieta(konkreti, naujasRankinis) {
    if (naujasRankinis !== undefined) setRankinis(naujasRankinis)
    const baseinas = filtruotosVietos()
    let saltinis = baseinas
    if (konkreti) {
      saltinis = [konkreti]
    } else if (pasirinkta && baseinas.length > 1) {
      // Re-roll („Vežk kitur") — negrąžinam tos pačios vietos
      saltinis = baseinas.filter(v => v.id !== pasirinkta.id)
    }

    if (saltinis.length === 0) {
      setNieko(true)
      return
    }
    setNieko(false)

    const vieta = konkreti || saltinis[Math.floor(Math.random() * saltinis.length)]
    pridetiNeseniai(vieta)

    // Rekomendacijos — artimiausi kaimynai iš to paties filtruoto baseino
    const kitosVietos = baseinas
      .filter(v => v.id !== vieta.id)
      .sort((a, b) => {
        if (!lokacija) return Math.random() - 0.5
        const da = haversine(vieta.latitude, vieta.longitude, a.latitude, a.longitude)
        const db = haversine(vieta.latitude, vieta.longitude, b.latitude, b.longitude)
        return da - db
      })
      .slice(0, 5)

    setKitos(kitosVietos)

    // Konkreti vieta (pin arba rekomendacija) → tiesioginis, malonus
    // perjungimas be ruletės animacijos.
    if (konkreti) {
      setPasirinkta(vieta)
      return
    }

    // Atsitiktinė vieta („Vežk mane" arba „Vežk kitur") → pilna ruletės
    // animacija. Rezultato NEuždarom — animacija (z150) fade'inasi VIRŠ jo,
    // tad perėjimas sklandus iš to ekrano, kuriame buvai (rezultato ar pagrindinio).
    nuotraukaPasiruoseRef.current = false
    setAnimacija(vieta)

    const nuotr = vieta.nuotraukos?.[0] || vieta.nuotrauka_url
    if (nuotr) {
      const img = new Image()
      img.onload = () => { nuotraukaPasiruoseRef.current = true }
      img.src = nuotr
    } else {
      nuotraukaPasiruoseRef.current = true
    }
  }

  function togglePapildomai(chip) {
    setNieko(false)
    setPapildomai(prev =>
      prev.includes(chip) ? prev.filter(c => c !== chip) : [...prev, chip]
    )
  }

  const skaicius = filtruotosVietos().length

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '100dvh', background: '#141F1A', overflow: 'hidden' }}>
      <style>{`
        .atstumo-slankiklis { -webkit-appearance: none; appearance: none; height: 4px; border-radius: 2px; outline: none; }
        .atstumo-slankiklis::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 18px; height: 18px; border-radius: 50%; background: #E5A840; border: 2px solid #141F1A; box-shadow: 0 0 0 3px rgba(229,168,64,0.18); cursor: pointer; }
        .atstumo-slankiklis::-moz-range-thumb { width: 18px; height: 18px; border-radius: 50%; background: #E5A840; border: 2px solid #141F1A; cursor: pointer; }
      `}</style>

      {/* ── ŽEMĖLAPIO ZONA ── */}
      <div onClick={() => { if (!sheetMini) setSheetMini(true) }} style={{ position: 'fixed', inset: 0, cursor: 'pointer', zIndex: 1 }}>
        <Zemelapis
          vietos={zemelapioPaieska ? zemelapioPaieska.vietos : vietos}
          lokacija={lokacija}
          onVietaPasirinkta={(v) => pasirinktiVieta(v, true)}
          pasirinkta={null}
          aktyviosKategorijos={[]}
          pinPozicija={sheetMini ? 0.5 : 0.22}
          centruotiSignalas={centruotiSignalas}
          fitRibos={zemelapioPaieska ? zemelapioPaieska.vietos : null}
          fitApacia={zemelapioPaieska ? Math.min(Math.round((window.innerHeight || 700) * 0.52), 480) : 0}
          visaLietuva={!!zemelapioPaieska}
        />

        {/* Header */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 500, padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ background: 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', borderRadius: '20px', border: '1px solid rgba(240,232,213,0.08)', padding: '6px 12px', color: '#7A8A7E', fontSize: '13px', letterSpacing: '0.14em' }}>
            kelionių
            <span style={{ display: 'inline-block', width: '12px', height: '1.5px', background: '#E5A840', margin: '0 6px', verticalAlign: 'middle' }} />
            app
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* Buvau čia — greitas prisiminimas (kamerėlė) */}
            <button
              ref={kameraRef}
              onClick={(e) => { e.stopPropagation(); atidarytiKamera() }}
              aria-label="Buvau čia"
              style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(229,168,64,0.18)', backdropFilter: 'blur(10px)', border: '1px solid rgba(229,168,64,0.45)', color: '#E5A840', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                <circle cx="12" cy="13" r="4" />
              </svg>
            </button>
            {/* Grąžinti į mano vietą */}
            <button
              onClick={(e) => { e.stopPropagation(); if (lokacija) { setCentruotiSignalas(n => n + 1) } else { patikrinti() } }}
              aria-label="Grąžinti į mano vietą"
              style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', border: '1px solid rgba(240,232,213,0.1)', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="3.5" />
                <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
              </svg>
            </button>
            {/* Profilis */}
            <button
              onClick={(e) => { e.stopPropagation(); setProfilis(true) }}
              aria-label="Profilis"
              style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', border: '1px solid rgba(240,232,213,0.1)', color: '#F0E8D5', fontFamily: "'Lora', Georgia, serif", fontSize: '13px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
            >
              I
            </button>
          </div>
        </div>

      </div>

      {/* ── BOTTOM SHEET ── */}
      <div
        onClick={(e) => { if (sheetMini) { e.stopPropagation(); setSheetMini(false); } }}
        onTouchEnd={(e) => { if (sheetMini) { e.stopPropagation(); setSheetMini(false); } }}
        style={{ display: pasirinkta ? 'none' : 'flex', position: 'absolute', bottom: 0, left: 0, right: 0, height: zemelapioPaieska ? '52dvh' : '72dvh', maxHeight: zemelapioPaieska ? '480px' : '640px', background: '#141F1A', borderRadius: '20px 20px 0 0', borderTop: '1px solid #2A3B32', flexDirection: 'column', padding: 0, transition: 'transform 0.35s cubic-bezier(0.32,0.72,0,1)', transform: sheetMini ? 'translateY(calc(100% - 52px))' : 'translateY(0)', overflowY: 'hidden', zIndex: 2 }}>

        {/* Handle */}
        <div
          onClick={(e) => { e.stopPropagation(); setSheetMini(false); }}
          onTouchEnd={(e) => { e.stopPropagation(); setSheetMini(false); }}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', padding: '8px 0 10px', cursor: 'pointer' }}
        >
          {sheetMini && (
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" style={{ opacity: 0.5, transition: 'opacity 0.3s ease' }}>
              <path d="M1 8.5L8 1.5L15 8.5" stroke="#E5A840" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
          <div style={{
            width: sheetMini ? '48px' : '36px',
            height: '4px',
            background: sheetMini ? 'rgba(229,168,64,0.5)' : 'rgba(240,232,213,0.2)',
            borderRadius: '2px',
            transition: 'all 0.3s ease'
          }} />
        </div>

        {zemelapioPaieska ? (
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            {/* Paieškos rezultatų sąrašas (kaip Google Maps) */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '2px 20px 10px' }}>
              <span style={{ color: '#F0E8D5', fontSize: '14px', fontWeight: 500, flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>„{zemelapioPaieska.fraze}" <span style={{ color: '#7A8A7E', fontWeight: 400 }}>· {zemelapioPaieska.vietos.length} {vietosZodis(zemelapioPaieska.vietos.length)}</span></span>
              <button onClick={() => setZemelapioPaieska(null)} aria-label="Išvalyti" style={{ width: '30px', height: '30px', borderRadius: '50%', background: 'rgba(240,232,213,0.08)', border: 'none', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
              </button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', minHeight: 0, padding: '0 16px calc(16px + env(safe-area-inset-bottom))' }}>
              {zemelapioPaieska.vietos.map(v => {
                const n = v.nuotraukos?.[0] || v.nuotrauka_url
                return (
                  <div
                    key={v.id}
                    onClick={() => setTimeout(() => pasirinktiVieta(v, true), 140)}
                    onPointerDown={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; e.currentTarget.style.background = 'rgba(240,232,213,0.05)' }}
                    onPointerUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = 'transparent' }}
                    onPointerLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = 'transparent' }}
                    style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '9px 8px', margin: '0 -4px', borderBottom: '1px solid #2A3B32', cursor: 'pointer', transition: 'transform 0.14s ease, background 0.14s ease' }}
                  >
                    <div style={{ width: '52px', height: '52px', borderRadius: '8px', overflow: 'hidden', background: '#1E2E27', flexShrink: 0 }}>
                      {n && <img src={n} alt={v.pavadinimas} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <p style={{ color: '#F0E8D5', fontSize: '14px', fontFamily: "'Lora', Georgia, serif", margin: 0, lineHeight: 1.2 }}>{v.pavadinimas}</p>
                      <p style={{ color: '#7A8A7E', fontSize: '11px', margin: '3px 0 0' }}>{[v.miestas, v.kategorija].filter(Boolean).join(' · ')}</p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>

          {/* Slenkama filtrų dalis */}
          <div ref={filtraiRef} style={{ padding: '0 22px', overflowY: 'auto', flex: 1, minHeight: 0 }}>

          {/* Editorial antraštė */}
          <div style={{ marginTop: '10px', marginBottom: '14px' }}>
            <h1 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: '27px', fontWeight: 500, letterSpacing: '-0.015em', margin: 0, lineHeight: 1.05 }}>
              Kur šiandien?
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginTop: '9px' }}>
              <span style={{ display: 'inline-block', width: '28px', height: '2px', background: '#E5A840' }} />
              <span style={{ color: '#7A8A7E', fontSize: '13px', letterSpacing: '0.02em' }}>rask vietą aplink tave</span>
            </div>
          </div>

          {/* Search bar (atidaro pilno ekrano paiešką) */}
          <button
            onClick={() => setPaieskaAtidaryta(true)}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '0 14px', height: '44px', background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: '10px', color: '#7A8A7E', fontSize: '13px', marginBottom: '16px', cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif', textAlign: 'left' }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" strokeWidth="1.85" stroke="#7A8A7E" strokeLinecap="round">
              <circle cx="10.5" cy="10.5" r="7" />
              <path d="M15.8 15.8l5 5" />
            </svg>
            Ieškoti vietos ar miesto…
          </button>

          {/* Kategorijos */}
          <div style={{ marginBottom: '14px' }}>
            <div style={{ color: '#7A8A7E', fontSize: '10px', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '8px' }}>Kategorija</div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {KATEGORIJOS.map(k => (
                <button
                  key={k.value}
                  onClick={() => { setNieko(false); setAktyviKategorija(k.value) }}
                  style={{ padding: '6px 11px', borderRadius: '6px', border: `1px solid ${aktyviKategorija === k.value ? 'rgba(229,168,64,0.4)' : '#2A3B32'}`, color: aktyviKategorija === k.value ? '#E5A840' : '#B0B8A8', fontSize: '11px', background: aktyviKategorija === k.value ? 'rgba(229,168,64,0.14)' : 'transparent', cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}
                >
                  {k.label}
                </button>
              ))}
            </div>
          </div>

          {/* Atstumas */}
          <div style={{ marginBottom: '14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#7A8A7E', fontSize: '10px', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Atstumas</span>
              <span style={{ color: '#F0E8D5', fontSize: '12px', fontWeight: 500 }}>iki {atstumas} km</span>
            </div>
            <input
              type="range"
              className="atstumo-slankiklis"
              min={5}
              max={300}
              value={atstumas}
              onChange={e => { setNieko(false); setAtstumas(Number(e.target.value)) }}
              style={{ width: '100%', background: `linear-gradient(to right, #E5A840 ${Math.round(((atstumas - 5) / 295) * 100)}%, #2A3B32 ${Math.round(((atstumas - 5) / 295) * 100)}%)` }}
            />
          </div>

          {/* Papildomai */}
          <div style={{ marginBottom: '14px' }}>
            <div style={{ color: '#7A8A7E', fontSize: '10px', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '8px' }}>Papildomai</div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {PAPILDOMAI_VARIANTAI.map(p => (
                <button
                  key={p}
                  onClick={() => togglePapildomai(p)}
                  style={{ padding: '6px 11px', borderRadius: '6px', border: `1px solid ${papildomai.includes(p) ? 'rgba(229,168,64,0.4)' : '#2A3B32'}`, color: papildomai.includes(p) ? '#E5A840' : '#B0B8A8', fontSize: '11px', background: papildomai.includes(p) ? 'rgba(229,168,64,0.14)' : 'transparent', cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          </div>

          {/* CTA — visada matomas apačioje */}
          <div style={{ flexShrink: 0, padding: '10px 22px calc(14px + env(safe-area-inset-bottom))', display: 'flex', flexDirection: 'column', gap: '8px', borderTop: '1px solid rgba(42,59,50,0.5)', background: '#141F1A' }}>
            {!nieko && skaicius > 0 && lokacija && (
              <div style={{ textAlign: 'center', color: '#B0B8A8', fontSize: '13px', marginBottom: '4px', letterSpacing: '0.01em' }}>
                aplink tave — <span style={{ color: '#E5A840', fontWeight: 500 }}>{skaicius}</span> {vietosZodis(skaicius)}
              </div>
            )}
            {nieko && (
              <div style={{ padding: '12px 14px', borderRadius: '10px', background: 'rgba(200,99,83,0.1)', border: '1px solid rgba(200,99,83,0.3)', marginBottom: '4px' }}>
                <p style={{ color: '#F0E8D5', fontSize: '13px', margin: 0, marginBottom: atstumas < 300 ? '8px' : 0 }}>
                  Su šiais filtrais iki {atstumas} km nieko neradau.
                </p>
                {atstumas < 300 && (
                  <button
                    onClick={() => { setNieko(false); setAtstumas(a => Math.min(a + 40, 300)) }}
                    style={{ background: 'transparent', border: 'none', color: '#E5A840', fontSize: '13px', fontWeight: 600, cursor: 'pointer', padding: 0, fontFamily: 'Syne, system-ui, sans-serif' }}
                  >
                    Praplėsti ratą iki {Math.min(atstumas + 40, 300)} km →
                  </button>
                )}
              </div>
            )}
            <button
              ref={vezkRef}
              onClick={() => pasirinktiVieta(null, false)}
              style={{ height: '56px', borderRadius: '12px', background: '#E5A840', color: '#141F1A', border: 'none', fontFamily: "'Lora', Georgia, serif", fontSize: '18px', fontWeight: 600, letterSpacing: '-0.01em', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', transition: 'background 0.12s ease, transform 0.1s ease', boxShadow: '0 0 0 6px rgba(229,168,64,0.08)' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#D19630' }}
              onMouseLeave={(e) => { e.currentTarget.style.background = '#E5A840'; e.currentTarget.style.transform = 'scale(1)' }}
              onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.97)'; e.currentTarget.style.background = '#D19630' }}
              onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = '#E5A840' }}
              onTouchStart={(e) => { e.currentTarget.style.transform = 'scale(0.97)'; e.currentTarget.style.background = '#D19630' }}
              onTouchEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = '#E5A840' }}
            >
              Vežk mane
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#141F1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </button>
            <button
              onClick={() => setSheetMini(true)}
              style={{ height: '42px', borderRadius: '10px', background: 'transparent', color: '#F0E8D5', border: '1px solid #3A4C42', fontFamily: 'Syne, system-ui, sans-serif', fontSize: '12px', fontWeight: 500, cursor: 'pointer' }}
            >
              Išsirinksiu pats
            </button>
          </div>

        </div>
        )}
      </div>

      {animacija && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 150 }}>
          <RuleteAnimacija
            vieta={animacija}
            onBaigta={() => {
              if (nuotraukaPasiruoseRef.current) {
                setPasirinkta(animacija); setAnimacija(null)
              } else {
                const tikrinti = setInterval(() => {
                  if (nuotraukaPasiruoseRef.current) {
                    clearInterval(tikrinti)
                    setPasirinkta(animacija); setAnimacija(null)
                  }
                }, 100)
              }
            }}
          />
        </div>
      )}
      {pasirinkta && (
        <RuleteRezultatas
          key={pasirinkta.id}
          vieta={pasirinkta}
          kitos={kitos}
          lokacija={lokacija}
          rankinis={rankinis}
          onUzdaryti={() => setPasirinkta(null)}
          vietos={vietos}
          onKita={(vieta) => pasirinktiVieta(vieta || null)}
          onZemelapisRezimas={() => { setPasirinkta(null); setSheetMini(true) }}
          onAplankyta={(zinute) => rodytiToast(zinute)}
        />
      )}

      <ProfilioLentele
        atidaryta={profilis}
        onClose={() => setProfilis(false)}
        onIssaugotos={() => { setProfilis(false); setIssaugotosAtidaryta(true) }}
        onIssukiai={() => { setProfilis(false); setIssukiaiAtidaryta(true) }}
        onNustatymai={() => { setProfilis(false); setNustatymaiAtidaryta(true) }}
        onKalba={() => { setProfilis(false); setKalbaAtidaryta(true) }}
        onPrenumerata={() => { setProfilis(false); setPrenumerataAtidaryta(true) }}
        onPagalba={() => { setProfilis(false); setPagalbaAtidaryta(true) }}
        onPakviesk={pakviestiDrauga}
        onPadekTobulinti={() => { setProfilis(false); setAtsiliepimasAtidaryta(true) }}
        onPaskyra={() => { setProfilis(false); setProfilisEkranas(true) }}
        onNetrukus={(pav) => rodytiToast(`${pav} — netrukus`)}
      />

      <IssaugotosVietos
        atidaryta={issaugotosAtidaryta}
        onClose={() => setIssaugotosAtidaryta(false)}
        onVietaPasirinkta={(vieta) => { setIssaugotosAtidaryta(false); pasirinktiVieta(vieta, true) }}
      />

      <AtsiliepimasEkranas
        atidaryta={atsiliepimasAtidaryta}
        onClose={() => setAtsiliepimasAtidaryta(false)}
        onIssiusta={(zinute) => rodytiToast(zinute)}
      />

      <PaieskaEkranas
        atidaryta={paieskaAtidaryta}
        onClose={() => setPaieskaAtidaryta(false)}
        vietos={vietos}
        onVietaPasirinkta={(vieta) => { setPaieskaAtidaryta(false); pasirinktiVieta(vieta, true) }}
        onRodytiZemelapyje={rodytiZemelapyje}
      />

      <Profilis
        atidaryta={profilisEkranas}
        onClose={() => setProfilisEkranas(false)}
        visosVietos={vietos}
        onZenkliukai={() => setZenkliukaiAtidaryta(true)}
      />

      <ZenkliukaiEkranas
        atidaryta={zenkliukaiAtidaryta}
        onClose={() => setZenkliukaiAtidaryta(false)}
        visosVietos={vietos}
      />

      <IssukiaiEkranas
        atidaryta={issukiaiAtidaryta}
        onClose={() => setIssukiaiAtidaryta(false)}
        visosVietos={vietos}
      />

      <NustatymaiEkranas
        atidaryta={nustatymaiAtidaryta}
        onClose={() => setNustatymaiAtidaryta(false)}
        onToast={rodytiToast}
      />

      <KalbaEkranas
        atidaryta={kalbaAtidaryta}
        onClose={() => setKalbaAtidaryta(false)}
        onToast={rodytiToast}
      />

      <PrenumerataEkranas
        atidaryta={prenumerataAtidaryta}
        onClose={() => setPrenumerataAtidaryta(false)}
        onToast={rodytiToast}
      />

      <PagalbaEkranas
        atidaryta={pagalbaAtidaryta}
        onClose={() => setPagalbaAtidaryta(false)}
        onToast={rodytiToast}
        onKontaktas={() => { setPagalbaAtidaryta(false); setAtsiliepimasAtidaryta(true) }}
      />

      {/* Globalus „Buvau čia" — kamera + patvirtinimas */}
      <input ref={globalusFailoRef} type="file" accept="image/*" capture="environment" onChange={globaliNuotrauka} style={{ display: 'none' }} />
      <PrisiminimoPatvirtinimas
        taskas={prTaskas}
        kandidatai={prKandidatai}
        vieta={prVieta}
        onPasirink={(v) => setPrVieta(v)}
        onSave={issaugotiGlobaluPrisiminima}
        onClose={() => { if (!prSaugoma) { setPrTaskas(null); setPrVieta(null); setPrKandidatai([]) } }}
        saugoma={prSaugoma}
      />

      {pagrZingsnis >= 0 && !pasirinkta && !animacija && !profilis && !profilisEkranas && !paieskaAtidaryta && !issaugotosAtidaryta && !atsiliepimasAtidaryta && !zenkliukaiAtidaryta && !issukiaiAtidaryta && !prTaskas && (() => {
        const z = PAGR_ZINGSNIAI[pagrZingsnis]
        const zemelapis = z.id === 'ob_zemelapis'
        const H = window.innerHeight || 800, W = window.innerWidth || 390
        const mapRect = zemelapis ? { top: 54, left: 8, width: W - 16, height: H - 54 - 60, bottom: H - 60 } : undefined
        return (
          <CoachMark
            key={z.id}
            targetRef={zemelapis ? undefined : z.ref}
            rect={mapRect}
            svarbus={z.id === 'ob_taskai'}
            antraste={z.antraste}
            tekstas={z.tekstas}
            zingsnis={`${pagrZingsnis + 1} / ${PAGR_ZINGSNIAI.length}`}
            paskutinis={pagrZingsnis === PAGR_ZINGSNIAI.length - 1}
            onKitas={pagrKitas}
            onPraleisti={pagrPraleisti}
          />
        )
      })()}

      {toast && (
        <div style={{ position: 'fixed', bottom: '32px', left: '50%', transform: 'translateX(-50%)', zIndex: 1100, background: '#28382F', border: '1px solid #3A4C42', borderRadius: '10px', padding: '11px 16px', color: '#F0E8D5', fontSize: '13px', fontFamily: 'Syne, system-ui, sans-serif', boxShadow: '0 8px 24px rgba(0,0,0,0.4)', whiteSpace: 'nowrap' }}>
          {toast}
        </div>
      )}
    </div>
  )
}

export default Rulete
